export default __webpack_public_path__ + "static/media/09.e4b8ae07.jpg";